'use client'

import { MessageSquareOffIcon, MessageSquareTextIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import { useAppDispatch, useAppSelector } from '@/redux/hooks'
import { AssistantActions } from '@/redux/reducers/assistant'

export const SidebarAssistantToggle = () => {
  const isSideChatOpen = useAppSelector(state => state.assistant.isSideChatOpen)
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const text = isSideChatOpen
    ? t('navigation.header.hideChatButton')
    : t('navigation.header.showChatButton')

  const texts: string[] = [
    t('navigation.header.hideChatButton'),
    t('navigation.header.showChatButton'),
  ]
  const maxTextLength = Math.max(...texts.map(t => t.length))

  return (
    <Button
      aria-label={text}
      onClick={() => dispatch(AssistantActions.toggleSideChat())}
      style={{
        width: `${maxTextLength + 4}ch`,
      }}
      variant={isSideChatOpen ? 'secondary' : 'default'}
    >
      {isSideChatOpen ? <MessageSquareOffIcon /> : <MessageSquareTextIcon />}
      {text}
      <span className="sr-only">{text}</span>
    </Button>
  )
}
